import { GroupExtensionConfig, GroupExtensionFactory } from '../Extension';
import { SlackGroupExtension } from './SlackGroupExtension';

export class SlackGroupExtensionFactory implements GroupExtensionFactory<SlackGroupExtension> {
  create(config: GroupExtensionConfig): SlackGroupExtension {
    return config as SlackGroupExtension;
  }
}
